import styles from 'css/Button.module.css'
import Lib from 'library/'

const Button = ({ id, className, onClick, disabled, style, children = "확인" }) => {

	const _className = Lib.getStyle(className, styles)

	return (
		<button id={id} className={`${styles.btn} ${_className}`} onClick={onClick} disabled={disabled} style={style}>
			{ children }
		</button>
	)
}

export default Button
